import React, { Component } from 'react'
import { Div, Colorway, Span } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'
import { Table } from '@driftt/tide-table'
import { Columns, SourcedColumns } from './constants'
import { ExampleDriftContact } from 'constants/ExampleContact'
import { RowFormatter, SourcedRowFormatter } from './formatters'

class PropertyLists extends Component {
  constructor(props) {
    super(props)

    this.state = {
      exampleContact: ExampleDriftContact
    }
  }

  onPropertySelect = (propertyName, isSelected) => {
    const { onChange } = this.props

    onChange(propertyName, isSelected)
  }

  onPropertyArchive = (property, status) => {
    const { onArchive } = this.props

    onArchive(property, status)
  }

  render() {
    const { properties, isLoading, nameFilter, isSourced, disableAll, source, attributeType } = this.props
    const { exampleContact } = this.state

    return (
      <Div className="contacts-drift-properties">
        <Table 
          className="contacts-drift-properties-table"
          data={isSourced ?
            properties.map((property, index) => SourcedRowFormatter(property, index, this.onPropertySelect, nameFilter, disableAll, source, this.onPropertyArchive)) :
            properties.map((property, index) => RowFormatter(property, index, exampleContact, this.onPropertySelect, nameFilter, this.onPropertyArchive, attributeType))}
          columns={isSourced ? SourcedColumns : Columns}
        />
        { !isLoading && properties.length === 0 &&
          <Div className="contact-property-list-empty-icon-container">
            <Colorway type="2">
              <Icon name="cw-empty-search" />
            </Colorway>
            <Span>
              You don't have any {attributeType} attributes!
            </Span>
          </Div>
        }
      </Div>
    )
  }
}

export default PropertyLists
